<app-card icon="flight" title="Airline Statistics" iconGradient="from-cyan-500 to-blue-600" class="h-full">
    <ng-template #headerTemplate>
        <div class="ml-auto">
            <app-excel-button [data]="exportData()" [excelTitle]="'airline-statistics'" [columns]="cols"></app-excel-button>
        </div>
    </ng-template>
    <app-table-component
        [cols]="cols"
        [data]="airlineStatisticsData() || []"
        [loading]="loading()"
        [oddRowColor]="'#cae6ff'"
    ></app-table-component>
</app-card>
